export const FulfillmentPlanFulfillmentType = Object.freeze({
  Manual: 'Manual',
  Shipment: 'Shipment',
  External: 'External',
});
